import confetti from "canvas-confetti";

/**
 * Dispara um estourinho bem sutil de confete a partir de um elemento,
 * usado no botão "Amei".
 */
export function fireHeartConfetti(originEl?: Element | null) {
  if (!originEl || typeof window === "undefined") return;

  const rect = originEl.getBoundingClientRect();
  const x = (rect.left + rect.width / 2) / window.innerWidth;
  const y = (rect.top + rect.height / 2) / window.innerHeight;

  confetti({
    particleCount: 8,
    spread: 28,
    startVelocity: 8,
    gravity: 0.9,
    ticks: 90,
    origin: { x, y },
    colors: ["#f43f5e", "#fb7185", "#e11d48", "#9231FF"],
    shapes: ["circle"],
    scalar: 0.35,
    disableForReducedMotion: true,
    zIndex: 9999,
  });
}

export function fireRitualConfetti() {
  if (typeof window === "undefined") return;

  const colors = ["#9231FF", "#6D5DFB", "#F43F5E", "#F8FAFC"];
  const burst = (origin: { x: number; y: number }, angle: number) => confetti({
    particleCount: 42,
    spread: 58,
    startVelocity: 28,
    gravity: 0.85,
    ticks: 150,
    origin,
    angle,
    colors,
    shapes: ["circle", "square"],
    scalar: 0.75,
    disableForReducedMotion: true,
    zIndex: 9999,
  });

  burst({ x: 0.18, y: 0.58 }, 55);
  burst({ x: 0.82, y: 0.58 }, 125);
}

